/**
 * Converts outline points from perfect-freehand's getStroke to SVG path data.
 * @see https://www.npmjs.com/package/perfect-freehand#rendering
 */
export function getSvgPathFromStroke(points) {
  let closed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const len = points.length;
  if (len < 4) return '';
  const average = (a, b) => (a + b) / 2;
  let a = points[0];
  let b = points[1];
  const c = points[2];
  let result = "M".concat(a[0].toFixed(2), ",").concat(a[1].toFixed(2), " Q").concat(b[0].toFixed(2), ",").concat(b[1].toFixed(2), " ").concat(average(b[0], c[0]).toFixed(2), ",").concat(average(b[1], c[1]).toFixed(2), " T");
  for (let i = 2, max = len - 1; i < max; i++) {
    a = points[i];
    b = points[i + 1];
    result += "".concat(average(a[0], b[0]).toFixed(2), ",").concat(average(a[1], b[1]).toFixed(2), " ");
  }
  if (closed) result += 'Z';
  return result;
}